/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangeDnaLabel } from '../../models/change-dna-label';

export interface ChangeDnaLabel$Params {
  profileId: string;
  id: string;
      body?: ChangeDnaLabel
}

export function changeDnaLabel(http: HttpClient, rootUrl: string, params: ChangeDnaLabel$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, changeDnaLabel.PATH, 'put');
  if (params) {
    rb.path('profileId', params.profileId, {});
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

changeDnaLabel.PATH = '/studentprofile/{profileId}/dna/{id}/label';
